<template>
  <div>
    <a-dialog-window :value="value" @input="$emit('input')">
      <template v-slot:title
        >{{ id ? data.name : "Новый" }}
        <small v-if="id"> ({{ id }})</small>
      </template>
      <li v-for="(el, index) in data" :key="index">
        <s-element
          v-model="data[index].value"
          :model="model"
          @validate="setValue($event)"
        />
      </li>
      <template v-slot:actions>
        <v-spacer></v-spacer>
        <v-btn @click="submit()" color="primary">Записать</v-btn>
        <v-btn v-if="id" @click="removeDialogShow = true" color="error"
          >Удалить</v-btn
        >
        <v-btn @click="$emit('input')">Закрыть</v-btn>
      </template>
    </a-dialog-window>
    <a-dialog-window v-model="removeDialogShow">
      Вы действительно хотите удалить этот элемент?
      <template v-slot:actions>
        <v-spacer></v-spacer>
        <v-btn @click="remove(api, id)" color="error">Удалить</v-btn>
        <v-btn @click="removeDialogShow = false">Отмена</v-btn>
        <v-spacer></v-spacer>
      </template>
    </a-dialog-window>
  </div>
</template>

<script>
import { getForm, submitForm, removeEl } from "../../components/mixings";

export default {
  mixins: [getForm, submitForm, removeEl],

  props: {
    value: Boolean,
    id: Number,
  },
  data() {
    return {
      api: "/config",
      model: [
        { name: "name", title: "имя свойства", type: "string", class: "" },
        {
          name: "type",
          title: "тип",
          type: "select",
          options: ["string", "array", "object"],
        },
        { name: "value", title: "Value", type: "string", class: "" },
      ],
      removeDialogShow: false,
      data: [{ name: "", type: "string", value: "" }],
      valueOpt: null,
    };
  },
  methods: {
    setValue(e) {
      console.log("setValue", e);
    },
    afterRemove(data) {
      this.removeDialogShow = false;
      this.$emit("input");
      this.$router.push({ name: "considers" });
    },
    afterSave(data, status) {
      if (status) this.$emit("input");
    },
    async post(config, api) {
      let data = {
        config: { 
          value: "fdfdfdf",
          dictionary: {
            nearby: ["кафе", "Ресторан", "Парк", "Торговый центр"],
          },
        },
      };
      this.loading = true;
      let response = await this.$axios.post(api, data);
      this.loading = false;
      let status = response.data.status == "ok";
      if (response.data.data) {
        Object.assign(this.data, response.data.data);
        this.$root.$emit("show-info", {
          text: "Данные записаны",
        });
      }
      this.afterSave(this.data, status);
    },
  },
};
</script>